
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"92","height":"92","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.123 3.897C43.72.7 48.28.7 49.877 3.897l40.158 80.328c1.441 2.883-.655 6.275-3.878 6.275H5.843c-3.223 0-5.32-3.392-3.878-6.275L42.123 3.897z","stroke":"#000577","stroke-width":"3"}}),_c('path',{attrs:{"d":"M43.125 24.875a2.875 2.875 0 015.75 0V68a2.875 2.875 0 01-5.75 0V24.875zM43.125 79.5a2.875 2.875 0 115.75 0 2.875 2.875 0 01-5.75 0z","fill":"#AF3ED8"}})])
          )
        }
      }
    